module.exports = __webpack_public_path__ + "img/CB0010_hamochi_color_hamochi_wizard.5d1a39fa.png";